import { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import menuItems from './menuData';
import { DEFAULT_PAGE } from "../../constants";
import SidebarItem from './SidebarItem';
import styles from './Sidebar.module.scss';
import logo from '../../assets/images/logo.svg';
import pharoIcon from '../../assets/images/pharo-icon.png';
import { Button } from "react-bootstrap";
import Icon from "./Icon";

const SidebarNew = ({ access, subscription, onToggle }) => {
    const pageLocation = useSelector((state) => state.location.currentLocation);
    const [section, setSection] = useState(DEFAULT_PAGE);
    const [collapse, setCollapse] = useState(false);

    useEffect(() => {
        setSection(pageLocation.name);
    }, [pageLocation, section]);

    const handleCollapse = () => {
        setCollapse(!collapse);
        onToggle(!collapse);
    };

    return (
        <section className={`bg-primary d-flex flex-column ${styles.sidebar} ${collapse ? styles.collapsed : ''}`}>
            <div className={`flex-shrink-0 px-3 ${styles.logoWrap}`}>
                <img src={collapse ? pharoIcon : logo} alt="Predict Health" className={`${collapse ? styles.collapseLogo : styles.logo}`} />
            </div>
            <Button
                className={`${styles.collapsePanel} ${collapse && styles.collapsed} position-absolute border-0 rounded-circle`}
                onClick={handleCollapse}
            >
                <Icon className='color-white' icon={collapse ? "arrow-right" : "arrow-left"} size={24} />
            </Button>
            <div className="flex-grow-1 pb-3">
                {
                    (access && subscription) &&
                    <nav className={styles.mainNav}>
                        {
                            menuItems?.map((item, index) => {
                                const key = `${item.label.replace(' ', '-').toLowerCase()}-${index}`;
                                return item.label === section && <SidebarItem key={key} item={item} collapse={collapse} />
                            })
                        }
                    </nav>
                }
            </div>
        </section>
    );
}

export default SidebarNew;
